import React from 'react';
import { Stack, Skeleton } from '@mui/material/';
// import styles from '../../../features/applications/GlobalDataEntry/style';

const styles = {
  container: {
    marginLeft: -1
  },
  Checkbox: { marginTop: 2 },
  CheckboxPin: { marginTop: 2, marginLeft: 22 },
  roleContainer: { m: 1, marginLeft: 0.5, marginTop: 2, width: 250 },
  additionalPermission: { m: 1, marginLeft: 2, marginTop: 2, width: 285 },
  ButtonContainer: { marginTop: 5, textAlign: 'right', marginLeft: -2 },
  clrButton: {
    marginRight: 2
  },
  dropDownFieldsGrid: {
    marginTop: 2.5
  }
};

export default function skeleton() {
  return (
    <div style={{margin: '20px'}}>
      <Stack spacing={3} direction="row" sx={styles.dropDownFieldsGrid}>
        <Skeleton variant="rectangular" width={250} height={50} sx={{ borderRadius: '7px' }} />
        <Skeleton variant="rectangular" width={250} height={50} sx={{ borderRadius: '7px' }} />
        <Skeleton variant="rectangular" width={250} height={50} sx={{ borderRadius: '7px' }} />
        <Skeleton variant="rectangular" width={100} height={50} sx={{ borderRadius: '7px' }} />
      </Stack>
      <Stack spacing={3} direction="row" sx={styles.dropDownFieldsGrid}>
        <Skeleton variant="rectangular" width={250} height={50} sx={{ borderRadius: '7px' }} />
        <Skeleton variant="rectangular" width={250} height={50} sx={{ borderRadius: '7px' }} />
      </Stack>
      <Stack spacing={3} direction="row" sx={styles.dropDownFieldsGrid}>
        <Skeleton variant="rectangular" width={250} height={50} sx={{ borderRadius: '7px' }} />
        <Skeleton variant="rectangular" width={250} height={50} sx={{ borderRadius: '7px' }} />
        <Skeleton variant="rectangular" width={250} height={50} sx={{ borderRadius: '7px' }} />
        <Skeleton variant="rectangular" width={250} height={50} sx={{ borderRadius: '7px' }} />
      </Stack>
      <Stack spacing={3} direction="row" sx={styles.dropDownFieldsGrid}>
        <Skeleton variant="rectangular" width={250} height={50} sx={{ borderRadius: '7px' }} />
        <Skeleton variant="rectangular" width={250} height={50} sx={{ borderRadius: '7px' }} />
        <Skeleton variant="rectangular" width={250} height={50} sx={{ borderRadius: '7px' }} />
        <Skeleton variant="rectangular" width={250} height={50} sx={{ borderRadius: '7px' }} />
      </Stack>
      <Stack spacing={3} direction="row" sx={styles.dropDownFieldsGrid}>
        <Skeleton variant="rectangular" width={250} height={50} sx={{ borderRadius: '7px' }} />
        <Skeleton variant="rectangular" width={250} height={50} sx={{ borderRadius: '7px' }} />
        <Skeleton variant="rectangular" width={250} height={50} sx={{ borderRadius: '7px' }} />
      </Stack>
      <Stack spacing={3} direction="row" sx={styles.dropDownFieldsGrid}>
        <Skeleton variant="rectangular" width={250} height={50} sx={{ borderRadius: '7px' }} />
        <Skeleton variant="rectangular" width={250} height={50} sx={{ borderRadius: '7px' }} />
        <Skeleton variant="rectangular" width={100} height={50} sx={{ borderRadius: '7px' }} />
        <Skeleton variant="rectangular" width={100} height={50} sx={{ borderRadius: '7px' }} />
      </Stack>
    </div>
  );
}
